import React from "react";
import { useParams, useLocation } from "react-router-dom";
import ConsultationWizard from "../consultation/ConsultationWizard";

const ConsultationWizardWrapper: React.FC = () => {
  const { patientId } = useParams<{ patientId: string }>();
  const location = useLocation();
  const { constanteId, patientName, constante } = location.state || {};

  // Récupérer le rôle depuis le localStorage
  const role = (localStorage.getItem("role") || "doctor") as
    | "admin"
    | "doctor"
    | "secretary";

  

  // Validation des paramètres requis
  if (!patientId) {
    return (
      <div className="p-6 bg-red-50 border border-red-200 rounded-lg">
        <h3 className="text-lg font-medium text-red-800 mb-2">
          Erreur de paramètres
        </h3>
        <p className="text-red-700">ID du patient manquant dans l'URL.</p>
        <p className="text-sm text-red-600 mt-2">
          URL attendue: /doctor/dashboard/consultation/new/[patientId]
        </p>
      </div>
    );
  }

  return (
    <div className="p-6">
      <ConsultationWizard
        patientId={patientId}
        constanteId={constanteId || ""}
        patientName={patientName || ""}
        role={role}
        constante={constante}
      />
    </div>
  );
};

export default ConsultationWizardWrapper;
